<template>
    <div class="sidebar"
         :style="sidebarStyle"
         :data-color="backgroundColor"
         :data-image="backgroundImage">
        <div class="sidebar-wrapper">
            <div class="logo">
                <a href="/templates" class="simple-text">
                    <div class="logo-img">
                        <img>
                    </div>
                    {{title}}
                </a>
            </div>

            <slot name="content"></slot>
            <ul class="nav">
                <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
                <slot>
                    <sidebar-link v-for="(link,index) in sidebarLinks"
                                  :key="link.name + index"
                                  :to="link.path"
                                  @click="closeNavbar"
                                  :link="link">
                        <i :class="link.icon"></i>.nav-link
                        <p>{{link.name}}</p>
                    </sidebar-link>
                </slot>
            </ul>
        </div>
    </div>
</template>
<script>
    import SidebarLink from './SidebarLink.vue'

    export default {
        components: {
            SidebarLink
        },
        props: {
            title: {
                type: String,
                default: 'MUSE'
            },
            backgroundColor: {
                type: String,
                default: 'black',
                validator: (value) => {
                    let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
                    return acceptedValues.indexOf(value) !== -1
                }
            },
            backgroundImage: {
                type: String,
                default: '/static/img/muse1.jpg'
            },
            activeColor: {
                type: String,
                default: 'success',
                validator: (value) => {
                    let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
                    return acceptedValues.indexOf(value) !== -1
                }
            },
            sidebarLinks: {
                type: Array,
                default: () => []
            },
            autoClose: {
                type: Boolean,
                default: true
            }
        },
        provide () {
            return {
                autoClose: this.autoClose
            }
        },
        computed: {
            sidebarStyle () {
                return {
                    backgroundImage: `url(${this.backgroundImage})`
                }
            }
        }
    }

</script>
<style scoped>
    .logo-img {
        background-image: url('/static/img/logo.png');
        background-size: cover;
    }
    .simple-text {
        font-family: "SF Pro", sans-serif;
        letter-spacing: 3px;
        text-align: center;
        font-weight: 400 !important;
    }
    .sidebar:before {
        opacity: 0.6 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue